import { Link } from "../../components/Link/Link";
import { Label } from "../../components/Label/Label";
import blackCalendar from "../../images/icons/blackCalendar.svg";
import blackClock from "../../images/icons/blackClock.svg";

export const NewsCard = ({ card, array }) => {
  const moveSlideLatestResearch = (el) => {
    const activeSlide = document.querySelector(
      ".slider-research .swiper-slide-active"
    );

    if (activeSlide) {
      activeSlide.classList.remove("swiper-slide-active");

      const targetSlide = document.querySelector(
        `.slider-research [data-swiper-slide-index="${el}"]`
      );

      if (targetSlide) {
        targetSlide.classList.add("swiper-slide-active");

        const swiper = document.querySelector(".slider-research").swiper;

        if (swiper) {
          swiper.slideTo(el);
        }
      }
    }
  };

  return (
    <div className="latest-card">
      <Link href="/#">
        <div className="latest-card-image">
          <img src={card.image} alt={card.article} />
        </div>
        <Label>{card.label}</Label>
        <p className="description-demibold">{card.article}</p>

        <div className="news-time-data">
          <p className="body3">
            <span>
              <img src={blackCalendar} alt="black calendar" />
            </span>
            {card.date}
          </p>
          <p className="body3">
            <span>
              <img src={blackClock} alt="black clock" />
            </span>
            {card.read} MIN TO READ
          </p>
        </div>
      </Link>
      <div className="pagination-wrapper">
        {array?.map((el, index) => (
          <div
            onClick={() => moveSlideLatestResearch(index)}
            key={el.article}
            className={`pagination-dot black-background ${
              card.article === el.article && "active-dot"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
};
